import { View, ViewConfig } from "@lernetz/ts-lib";
import template from './SvgIcon.html';

var mounted;

export interface SvgIconViewConfig extends ViewConfig<SvgIcon> {
    symbols: string;
    shadowDom?: boolean;
}

export class SvgIconView extends View {

    symbols: string;
    shadowDom: boolean = false;

    constructor( config: SvgIconViewConfig ) {
        super( { template, data: {}, ...config } );
        this.symbols = config.symbols;
    }


    init() {
        if( mounted ) return;

        mounted = true;

        if( this.shadowDom ) {
            requestAnimationFrame( () => {
                mount( this.symbols, this.node.getRootNode() );
            });
        } else {
            mount( this.symbols, document.body );
        }
    }


}

export interface SvgIcon {
    name: string;
}


export function mount( symbols: string, root:Node ) {
    let div = document.createElement( 'div' );
    div.style.display = 'none';
    div.innerHTML = symbols;
    root.insertBefore( div, root.firstChild );
}


